var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useContext, Fragment, useMemo } from 'react';
import CollapsibleDiv from './CollapsibleDiv';
import { DataContext } from '../player/DataContext';
import customEventHandler from '../helper/customEvents';
import globalStore from '../store';
import { announce } from '../helper/announcer';
import { t } from 'i18next';
export var ColorEnum = {
    RED: '#f73530',
    YELLOW: '#f4c500',
    BLUE: '#2a90f7',
    BROWN: '#b5674d',
    ORANGE: '#ff8901',
    GREEN: '#1dac78',
    PURPLE: '#c038f7',
    BLACK: '#232323',
    WHITE: '#EDEDED',
    GRAY: '#64625F',
    DARK_NAVY_BLUE: '#001f5c',
};
var colorSvgMap = Object.keys(ColorEnum).reduce(function (acc, key) {
    var path = "./assets/images/colorN_".concat(key.toLowerCase(), ".svg");
    acc[key] = path;
    return acc;
}, {});
var ColorPicker = function (props) {
    var _a = props.isPositionRelative, isPositionRelative = _a === void 0 ? false : _a, _b = props.openAt, openAt = _b === void 0 ? 'right' : _b, collapsibleContainerCSS = props.collapsibleContainerCSS, _c = props.hrVisible, hrVisible = _c === void 0 ? true : _c, tooltipDirection = props.tooltipDirection, parentType = props.parentType, _d = props.useViewportPosition, useViewportPosition = _d === void 0 ? false : _d, _e = props.disabled, disabledProp = _e === void 0 ? false : _e;
    var _f = useContext(DataContext), selectedTool = _f.selectedTool, setColor = _f.setColor, color = _f.color, setText = _f.setText, setTable = _f.setTable, manipulative = _f.manipulative;
    var btnConfig = globalStore.useStoreState(function (state) { return state.jsonDataStore; }).btnConfig;
    var pickerData = btnConfig.colorPlate;
    var colorNameKey = useMemo(function () {
        var _a;
        var element = (_a = pickerData.elements) === null || _a === void 0 ? void 0 : _a[Object.keys(ColorEnum).indexOf(color)];
        return (element === null || element === void 0 ? void 0 : element.title) || 'text.colors';
    }, [color, pickerData.elements]);
    var mainButtonLabel = useMemo(function () { return t('text.colorsCurrently', { color: t(colorNameKey) }); }, [colorNameKey]);
    var selectColor = function (index) {
        var _a, _b, _c;
        var colorKey = Object.keys(ColorEnum)[index];
        var currColor = ((_a = pickerData.elements) === null || _a === void 0 ? void 0 : _a[index].color) || '';
        var colorName = ((_c = (_b = pickerData.elements) === null || _b === void 0 ? void 0 : _b[index]) === null || _c === void 0 ? void 0 : _c.title) || '';
        console.log('[color-debug] ColorPicker.selectColor', {
            index: index,
            colorKey: colorKey,
            currColor: currColor,
            previousContextColor: color,
            selectedTool: selectedTool,
        });
        setColor(colorKey);
        changeColorForSelectedText(currColor, colorKey);
        announce(t('text.colorChanged', { color: t(colorName) }));
    };
    var changeColorForSelectedText = function (currColor, colorKey) {
        var textUpdates = [];
        var tableUpdates = [];
        selectedTool.forEach(function (_tool) {
            var parts = _tool.split('_');
            var type = parts[0];
            switch (type) {
                case 'text':
                    // textUpdates.push(Number(parts[1]));
                    break;
                case 'table':
                    // tableUpdates.push({
                    //   tableIndex: Number(parts[1]),
                    //   row: Number(parts[2]),
                    //   col: Number(parts[3]),
                    // });
                    break;
                default:
                    break;
            }
        });
        if (textUpdates.length > 0) {
            setText(function (prev) {
                return prev.map(function (item, idx) {
                    return textUpdates.includes(idx) ? __assign(__assign({}, item), { data: __assign(__assign({}, item.data), { color: colorKey }) }) : item;
                });
            });
        }
        if (tableUpdates.length > 0) {
            setTable(function (prevTables) {
                return prevTables.map(function (table, tableIndex) {
                    var updatesForThisTable = tableUpdates.filter(function (u) { return u.tableIndex === tableIndex; });
                    if (updatesForThisTable.length === 0)
                        return table;
                    var colCount = table.data.colWidth.length;
                    var cellIndexFrom = function (row, col) { return row * colCount + col; };
                    var targetCellIndexes = new Set(updatesForThisTable.map(function (update) { return cellIndexFrom(update.row, update.col); }));
                    var updatedCellData = table.data.cellData.map(function (cell, index) {
                        return targetCellIndexes.has(index)
                            ? __assign(__assign({}, cell), { data: __assign(__assign({}, cell.data), { color: currColor }) }) : cell;
                    });
                    return __assign(__assign({}, table), { data: __assign(__assign({}, table.data), { cellData: updatedCellData }) });
                });
            });
        }
        console.log('[color-debug] ColorPicker.dispatchEvent colourChange', { currColor: currColor, colorKey: colorKey });
        customEventHandler.dispatchEvent('colourChange', { color: currColor, colorKey: colorKey });
    };
    var disableBtn = function () {
        var _bool = false;
        selectedTool.forEach(function (_selTool) {
            if (_selTool.startsWith('spinner') ||
                _selTool.startsWith('card') ||
                _selTool.startsWith('deck') ||
                _selTool.startsWith('timer') ||
                _selTool.startsWith('numberRacks') ||
                _selTool.startsWith('moneyPiece') ||
                _selTool.startsWith('linkingCube')) {
                _bool = true;
            }
            else if (_selTool.startsWith('analog')) {
                _bool = true;
                var matchManipulative = manipulative.find(function (m) { return m.data.id === _selTool; });
                if (matchManipulative) {
                    _bool = matchManipulative.data.fractionOverlayParts === null || matchManipulative.data.fractionOverlayParts === undefined;
                }
            }
            else if (_selTool.startsWith('arrayModel')) {
                var matchManipulative = manipulative.find(function (m) { return m.data.id === _selTool; });
                if (matchManipulative) {
                    var d = matchManipulative.data;
                    _bool = !(d.selectModeEnabled && d.selectedPartKey);
                }
                else {
                    _bool = true;
                }
            }
        });
        // if (selectedTool[0]) {
        //   if (selectedTool[0].startsWith('spinner')) {
        //     _bool = true;
        //   }
        // }
        return _bool;
    };
    return (_jsx(Fragment, { children: _jsx(CollapsibleDiv, { elements: pickerData.elements, mainElement: __assign(__assign({}, pickerData.imgSrc), { normal: colorSvgMap[color], hover: colorSvgMap[color], active: colorSvgMap[color], activeHover: colorSvgMap[color], normaldark: colorSvgMap[color], hoverdark: colorSvgMap[color], activedark: colorSvgMap[color], activeHoverdark: colorSvgMap[color] }), onSelect: selectColor, mainEleDefaultCSS: "sidebarBtn", mainEleNormalCSS: "colorSBtn", elemsDefaultCSS: "colorBtn", elemsNormalCSS: "colorNormalBtn", containerCSS: "colorsHolder", collapsibleContainerCSS: collapsibleContainerCSS, hr: hrVisible, showToolTip: true, title: pickerData.title, ariaLabel: pickerData.ariaLabel, ariaLabelTranslated: mainButtonLabel, isParentRelative: isPositionRelative, isInnerTooltipRelative: parentType === 'footerBtn', openAt: openAt, direction: tooltipDirection, parentType: parentType, disabled: disabledProp || disableBtn(), useViewportPosition: useViewportPosition }) }));
};
export default ColorPicker;
